import styled, { css } from 'styled-components';
import { darken } from 'polished';

import * as mx from 'core/styles/mixins';
import { Icon } from 'core/components/Icon/Icon.style';
import { FONT_NAMES, FONT_WEIGHT } from 'core/styles/fonts';

export const Circle = styled.div<{
	bgColor: string;
}>`
	${mx.circle('63px')}
	min-width: 63px;
	overflow: hidden;
	position: relative;
	margin-right: 16px;
	transition: background-color ${({ theme }) => theme.variables.baseTransition}
		ease;

	${({ theme, bgColor: colorName }) => css`
		${theme.css.getBackgroundAndText(colorName)}
	`}

	${Icon} {
		${mx.alignCentre}
		margin: 0;
	}
`;

export const Content = styled.div<{
	isActive?: boolean;
	bgColor: string;
}>`
	display: flex;
	padding-right: 20px;

	${({ theme, isActive = true, bgColor: colorName }) => {
		const isDark = theme.core.getCompositionIsDark(colorName);
		const color = theme.core.getCompositionColor(colorName);
		const lighterBackground = theme.core.getCompositionColor('blue-lighter');

		return (
			isActive &&
			css`
				&:hover,
				&:focus {
					cursor: pointer;

					${Circle} {
						background-color: ${isDark
							? lighterBackground
							: darken(0.1, color)};
					}

					.typography--custom__contactUsMethod--title {
						text-decoration: underline;
						color: ${isDark ? lighterBackground : color}!important;
					}
				}

				&:focus {
					${mx.mimicFocus}
				}
			`
		);
	}}
`;

export const Title = styled.h4`
	font-size: 16px;
	line-height: 24px;
	font-family: ${FONT_NAMES.GOTHAM_ROUNDED_BOOKED};
	font-weight: ${FONT_WEIGHT.SEMI_BOLD};
`;

export const Text = styled.p`
	font-size: 14px;
	line-height: 20px;
	font-family: ${FONT_NAMES.OPEN_SANS};
	font-weight: ${FONT_WEIGHT.REGULAR};
`;
